import React, { FunctionComponent, useCallback } from 'react';

import Scroller from '../Scroller';
import Vignette, { VignetteProps } from '../VignetteScroller/Vignette';

import './VignetteScroller.css';

export type VignetteScrollerProps = {
  disableScroller?: boolean;
  items?: VignetteProps[];
};

const VignetteScroller: FunctionComponent<VignetteScrollerProps> = (props) => {
  const { items = [], disableScroller } = props;

  const renderDotAriaLabel = useCallback(
    (index: number) => {
      return items[index]?.title || '';
    },
    [items]
  );

  return (
    <Scroller
      showDots
      width="100%"
      renderDotAriaLabel={renderDotAriaLabel}
      ContainerProps={{
        className: `vignette-scroller ${disableScroller ? 'vignette-scroller--no-scroller' : ''}`,
      }}
      ItemProps={{ className: 'vignette-scroller__item' }}
    >
      {items.map((item, index) => {
        const { body, image, title } = item;
        return (
          <Vignette
            className="vignette-scroller__vignette"
            key={index}
            body={body}
            image={image}
            title={title}
          />
        );
      })}
    </Scroller>
  );
};
export default VignetteScroller;
